import { getConsentCategoryIds } from "./getConsentCategoryIds";
import { asosGlobalNamespace } from "@template/constants";
import { ONETRUST_CONSENT_CHANGED } from "./constants";
import { setCookieValue, removeCookie } from "../context/cookies";

export const emitConsentChangedEvent = () => {
  const consent = getConsentCategoryIds();
  window[asosGlobalNamespace].eventBus.emit(ONETRUST_CONSENT_CHANGED, consent);

  window.OneTrust.OnConsentChanged(async event => {
    if (event.detail.includes("C0003")) {
      const customerGuid =
        await window.asos.sdk.identity.customer.customerGuid();
      setCookieValue("asos-cgd26", customerGuid, {
        secure: true,
        sameSite: "Lax"
      });
      removeCookie("temp-asos-cgd26");
    } else {
      removeCookie("asos-cgd26");
    }
  });
};
